// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3fyv-","ranges":"BmiRanges_ranges__vr48Y"};